import React, { useState } from 'react';
import { StarIcon, ArrowLeftIcon, ArrowRightIcon, ExternalLinkIcon } from 'lucide-react';
import { Norden } from './Norden';
export const Reviews: React.FC = () => {
  const reviews = [{
    name: 'Carla van Hilten-Deuzeman',
    company: 'Eigenaar metcarla.NL',
    rating: 5,
    text: 'Superblij ben ik met mijn website. Wat begon als een droom, krijgt nu gestalte. Samen met Noord Digital hebben we gebrainstormd, nagedacht, geschaafd en geschreven om een website te maken die uitstraalt wie ik ben. Snel schakelen, meedenken, vriendelijk en gewoon heel erg aardig. Ik kan ze van harte aanbevelen.'
  }, {
    name: 'Pim Dekker',
    company: 'Eigenaar Jaepie-Jaepie',
    rating: 5,
    text: 'Goede service! Snel en makkelijk contact en altijd zo geregeld. Meedenken in oplossingen, ik hou er van!'
  }, {
    name: 'Jens Wiegers',
    company: 'Eigenaar Wiegers Iconic Nutrition',
    rating: 5,
    text: 'De samenwerking met Noord was vanaf het begin al erg prettig. Ze luisterden goed naar mijn wensen, communiceerden duidelijk en stonden altijd open voor feedback. Het eindresultaat is precies wat ik voor ogen had: een website die past bij mijn merk en doelgroep.'
  }, {
    name: 'Basar Yuksel',
    company: 'Mede-eigenaar Common Frame Media',
    rating: 5,
    text: 'We are absolutely delighted with our new website. The design fits our wishes perfectly, adjustments were made quickly and communication was always clear and friendly. A great collaboration with an excellent result, highly recommended!'
  }, {
    name: 'Nicola de Roode',
    company: 'Eigenaar AS Family Fitness Center B.V.',
    rating: 5,
    text: 'Het is zo fijn om te weten dat een website in goede handen is. Korte lijnen, prettig contact, technisch sterk en persoonlijk betrokken. Wat voelt als een verlengstuk van ons team, een aanrader!'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextReview = () => {
    setCurrentIndex(prev => (prev + 2) % reviews.length);
  };
  const prevReview = () => {
    setCurrentIndex(prev => (prev - 2 + reviews.length) % reviews.length);
  };
  // Calculate visible reviews - show max 2 per slide
  const visibleReviews = reviews.slice(currentIndex, currentIndex + 2);
  if (visibleReviews.length < 2) {
    visibleReviews.push(...reviews.slice(0, 2 - visibleReviews.length));
  }
  return <div className="w-full bg-white py-16 md:py-[60px]" data-id="element-577">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-578">
        <div className="max-w-3xl mx-auto text-center mb-6" data-id="element-579">
          <h2 className="font-bold text-[#111827] mb-4" data-id="element-580">
            Wat onze klanten zeggen
          </h2>
          <p className="text-[#6B7280] mb-6 leading-relaxed text-lg" data-id="element-581">
            Van lokale ondernemers tot groeiende bedrijven, wij hebben al veel
            klanten geholpen met maatwerk webdesign en SEO geoptimaliseerde
            websites. Onze klanten waarderen onze professionele aanpak voor het
            laten maken van zakelijke websites. Lees hieronder wat zij over hun
            ervaring te vertellen hebben.
          </p>
          <div className="relative inline-block" data-id="element-582">
            <Norden variant="speechBubble" bubbleText="Onze klanten aan het woord" className="mb-8" data-id="element-583" />
          </div>
        </div>
        <div className="relative" data-id="element-584">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-585">
            {visibleReviews.map((review, index) => <div key={index} className="bg-white rounded-2xl shadow-[0_8px_16px_rgba(0,0,0,0.08)] p-5 h-full flex flex-col" data-id="element-586">
                <div className="flex mb-2" data-id="element-587">
                  {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-588" />)}
                </div>
                <p className="text-[#6B7280] mb-3 italic flex-grow text-base line-clamp-4" data-id="element-589">
                  "{review.text}"
                </p>
                <div className="mt-auto pt-3 border-t border-gray-100" data-id="element-590">
                  <p className="font-bold text-[#111827]" data-id="element-591">{review.name}</p>
                  <p className="text-sm text-[#6B7280]" data-id="element-592">{review.company}</p>
                </div>
              </div>)}
          </div>
          <div className="flex justify-center gap-4 mt-6" data-id="element-593">
            <button onClick={prevReview} className="p-2 rounded-full bg-[#F7F8FA] hover:bg-[#007AFF] hover:text-white transition-colors" aria-label="Vorige review" data-id="element-594">
              <ArrowLeftIcon className="h-5 w-5" data-id="element-595" />
            </button>
            <button onClick={nextReview} className="p-2 rounded-full bg-[#F7F8FA] hover:bg-[#007AFF] hover:text-white transition-colors" aria-label="Volgende review" data-id="element-596">
              <ArrowRightIcon className="h-5 w-5" data-id="element-597" />
            </button>
          </div>
          <div className="text-center mt-10" data-id="element-598">
            <a href="/portfolio" className="inline-flex items-center bg-[#007AFF] hover:bg-[#005FCC] text-white font-medium py-3 px-6 rounded-xl transition duration-300" data-id="element-599">
              Bekijk meer projecten
              <ExternalLinkIcon className="h-4 w-4 ml-2" data-id="element-600" />
            </a>
          </div>
        </div>
      </div>
    </div>;
};